// extracted by mini-css-extract-plugin
export default {"Carousel":"SwiperCarousel_Carousel__EjkZi"};